import { createAction } from "@reduxjs/toolkit";
import { DocumentsState } from "@documents/models";

export const changeDocumentsFiltersValues = createAction<Partial<DocumentsState["filters"]>>(
  "documents/changeDocumentsFiltersValues"
);
